import PropTypes from "prop-types";

import React from "react";

import classNames from "classnames";

export default class extends React.Component {
  static displayName = "Icon";

  static propTypes = {
    icon: PropTypes.string.isRequired,
    size: PropTypes.number,
    rotate: PropTypes.number,
    fixed: PropTypes.bool,
    spin: PropTypes.bool,
    disabled: PropTypes.bool,
    isBeforeText: PropTypes.bool,
    isAfterText: PropTypes.bool,
    onClick: PropTypes.func,
    style: PropTypes.object,
    title: PropTypes.string,
    /** Boolean: if using in a tooltip disable the title */
    disableTitle: PropTypes.bool,
  };

  static defaultProps = {
    size: 0,
    fixed: true,
    style: {},
  };

  render() {
    let rotation, size;
    const style = {
      marginRight: this.props.isBeforeText ? 8 : undefined,
      marginLeft: this.props.isAfterText ? 8 : undefined,
      ...this.props.style,
    };

    if (this.props.rotate) {
      rotation = `gt-icon-rotate-${this.props.rotate}`;
    }

    if (this.props.size > 1) {
      size = `gt-icon-${this.props.size}x`;
    } else if (this.props.size === 1) {
      size = "gt-icon-lg";
    }

    return (
      <i
        aria-label={this.props.title || `icon: ${this.props.icon}`}
        style={style}
        onClick={!this.props.disabled ? this.props.onClick : undefined}
        data-tour-id={this.props["data-tour-id"] || ""}
        className={classNames(`gt-icon gt-icon-${this.props.icon}`, this.props.className, rotation, size, {
          "is-disabled": this.props.disabled,
          "gt-icon-fw": this.props.fixed,
          "gt-icon-spin": this.props.spin,
        })}
      />
    );
  }
}
